import React, { useState } from 'react';

const MentalTracker = () => {
  const [mentalState, setMentalState] = useState(null);
  const [event, setEvent] = useState("");

  const handleSubmit = () => {
    const record = {
      date: new Date(),
      mentalState,
      event,
    };
    console.log("Record saved:", record);
    // localStorageに保存
    const records = JSON.parse(localStorage.getItem("mentalRecords")) || [];
    records.push(record);
    localStorage.setItem("mentalRecords", JSON.stringify(records));
    setMentalState(null);
    setEvent("");
  };

  return (
    <div>
      <h1>Mental Tracker</h1>
      <p>メンタル状態を選択:</p>
      {[1, 2, 3, 4].map((level) => (
        <button
          key={level}
          onClick={() => setMentalState(level)}
          style={{
            margin: '0 10px',
            backgroundColor: mentalState === level ? 'lightblue' : 'white',
          }}
        >
          {level}
        </button>
      ))}
      <p>出来事を記録:</p>
      <textarea
        value={event}
        onChange={(e) => setEvent(e.target.value)}
        placeholder="今日あったことを書きましょう"
        style={{ width: '100%', height: '100px' }}
      ></textarea>
      <br />
      <button onClick={handleSubmit}>記録を保存</button>
    </div>
  );
};

export default MentalTracker;
